import React from 'react';

const BackgroundAnimation = () => {
 
};

export default BackgroundAnimation;

